import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../fragments'

const DISH_TYPES_QUERY = gql`
  query dishTypes {
    dishTypes {
      results {
        ...MetadataNodeFragment
        children {
          ...MetadataNodeFragment
          children {
            ...MetadataNodeFragment
          }
        }
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default DISH_TYPES_QUERY
